export const badgeWrapperStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  cursor: 'default',
};

export const tooltipTitleStyles = {
  display: 'block',
  marginBottom: 0.5,
};

export const tooltipRowStyles = {
  display: 'flex',
};

export const tooltipValueStyles = {
  wordBreak: 'break-all',
};
